/* ROVELD: native Shopify forms are the baseline; progressively enhanced here. */
(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  const configElement = document.getElementById('ThemeConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const status = document.getElementById('GlobalStatus');
  const requests = new WeakMap();
  const observers = new WeakMap();
  let dialogOpener;
  let cartBusy = false;
  const say = (message) => { if (status) status.textContent = message; };
  const errorAt = (node, message) => { if (node) { node.textContent = message; node.hidden = !message; } };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openDialog(dialog, opener) {
    if (!dialog || !dialog.showModal) return false;
    document.querySelectorAll('dialog[open]').forEach((other) => other.close());
    dialogOpener = opener || document.activeElement;
    dialog.showModal();
    document.body.classList.add('dialog-open');
    return true;
  }
  function closeDialog(dialog) {
    if (dialog?.open) dialog.close();
  }
  function registerDialogs(scope = document) {
    scope.querySelectorAll('dialog').forEach((dialog) => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('close', () => {
        if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
        if (dialogOpener?.isConnected) dialogOpener.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
      });
    });
  }
  async function readResponse(response) {
    let data;
    try { data = await response.json(); } catch { throw new Error(config.strings.error); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : config.strings.error);
    return data;
  }
  async function refreshCart(html) {
    const dialog = document.getElementById('CartDrawer');
    if (!dialog) return;
    if (!html) {
      const url = new URL(config.routes.cart, location.origin);
      url.searchParams.set('section_id', 'cart-drawer');
      const response = await fetch(url, { headers: { 'Accept': 'text/html' } });
      if (!response.ok) throw new Error(config.strings.error);
      html = await response.text();
    }
    const incoming = parse(html).querySelector('[data-cart-drawer-content]');
    if (!incoming) throw new Error(config.strings.error);
    dialog.querySelector('[data-cart-drawer-content]').replaceWith(incoming);
    document.querySelectorAll('[data-cart-count]').forEach((counter) => { counter.textContent = incoming.dataset.cartCountValue; });
  }
  function setCartBusy(busy) {
    cartBusy = busy;
    const dialog = document.getElementById('CartDrawer');
    dialog?.setAttribute('aria-busy', String(busy));
    dialog?.querySelectorAll('input, button[name="checkout"]').forEach((input) => { input.disabled = busy; });
  }
  async function changeCart(key, quantity, focusId) {
    if (cartBusy) return;
    setCartBusy(true);
    try {
      const response = await fetch(config.routes.change, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: location.pathname })
      });
      const data = await readResponse(response);
      await refreshCart(data.sections?.['cart-drawer']);
      say(config.strings.updated);
      const target = focusId ? document.getElementById(focusId) : document.querySelector('#CartDrawer [data-dialog-close]');
      target?.focus({ preventScroll: true });
    } catch (error) {
      errorAt(document.querySelector('#CartDrawer [data-cart-error]'), error.message || config.strings.error);
    } finally { setCartBusy(false); }
  }
  async function addToCart(form, submitter) {
    const component = form.closest('[data-product-component]');
    if (component?.getAttribute('aria-busy') === 'true' || form.dataset.busy === 'true' || cartBusy) return;
    const button = form.querySelector('[data-add-to-cart]');
    if (button?.disabled || !form.reportValidity()) return;
    const originalText = button.querySelector('span')?.textContent;
    const errorNode = form.querySelector('[data-product-error]');
    form.dataset.busy = 'true';
    setCartBusy(true);
    component?.querySelectorAll('[data-option-value-id], [data-option-select]').forEach((node) => { node.disabled = true; });
    button.disabled = true;
    component?.querySelectorAll('[data-sticky-submit]').forEach((node) => { node.disabled = true; });
    if (button.querySelector('span')) button.querySelector('span').textContent = config.strings.adding;
    errorAt(errorNode, '');
    try {
      const body = new FormData(form);
      body.set('sections', 'cart-drawer');
      body.set('sections_url', location.pathname);
      const response = await fetch(config.routes.add, { method: 'POST', headers: { 'Accept': 'application/json' }, body });
      const data = await readResponse(response);
      say(config.strings.added);
      const dialog = document.getElementById('CartDrawer');
      if (dialog) {
        try {
          await refreshCart(data.sections?.['cart-drawer']);
          openDialog(dialog, submitter || button);
        } catch {
          // An add has succeeded. Never retry it when only rendering failed.
          location.assign(config.routes.cart);
        }
      } else location.assign(config.routes.cart);
    } catch (error) {
      errorAt(errorNode, error.message || config.strings.error);
      errorNode?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    } finally {
      form.dataset.busy = 'false';
      setCartBusy(false);
      component?.querySelectorAll('[data-option-value-id], [data-option-select]').forEach((node) => { node.disabled = false; });
      button.disabled = false;
      component?.querySelectorAll('[data-sticky-submit]').forEach((node) => { node.disabled = false; });
      if (button.querySelector('span')) button.querySelector('span').textContent = originalText;
    }
  }
  function selectMedia(gallery, id, smooth = false) {
    if (!gallery || !id) return;
    const target = [...gallery.querySelectorAll('[data-media-id]')].find((item) => item.dataset.mediaId === String(id));
    if (!target) return;
    const track = gallery.querySelector('.gallery-track');
    const offset = target.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    track.scrollTo({ left: offset, behavior: smooth && !reducedMotion() ? 'smooth' : 'instant' });
    gallery.querySelectorAll('[data-media-target]').forEach((thumb) => { thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaTarget === String(id))); });
  }
  function setupGallery(gallery) {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const track = gallery.querySelector('.gallery-track');
    requestAnimationFrame(() => selectMedia(gallery, gallery.dataset.activeMedia));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < .6) return;
        gallery.querySelectorAll('[data-media-target]').forEach((thumb) => { thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaTarget === entry.target.dataset.mediaId)); });
        gallery.querySelectorAll('video').forEach((video) => { if (!entry.target.contains(video)) video.pause(); });
      });
    }, { root: track, threshold: .6 });
    gallery.querySelectorAll('[data-media-id]').forEach((slide) => observer.observe(slide));
    observers.set(gallery, observer);
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      track.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: reducedMotion() ? 'instant' : 'smooth' });
    });
  }
  function setupSticky(component) {
    observers.get(component)?.disconnect();
    const sticky = component.querySelector('[data-sticky-atc]');
    const form = component.querySelector('[data-product-form]');
    if (!sticky || !form) return;
    const observer = new IntersectionObserver(([entry]) => {
      const active = !entry.isIntersecting && entry.boundingClientRect.bottom < 0 && matchMedia('(max-width: 989px)').matches;
      sticky.hidden = !active;
      document.body.classList.toggle('has-sticky-atc', active);
    }, { threshold: 0 });
    observer.observe(form);
    observers.set(component, observer);
  }
  function optionValues(component) {
    return [...component.querySelectorAll('[data-option-value-id]:checked, [data-option-select]')].map((node) => node.dataset.optionValueId || node.value);
  }
  async function updateVariant(component, changed) {
    if (component.querySelector('[data-product-form]')?.dataset.busy === 'true') return;
    requests.get(component)?.abort();
    const controller = new AbortController();
    requests.set(component, controller);
    const linkedProduct = changed.matches('select') ? changed.selectedOptions[0]?.dataset.productUrl : changed.dataset.productUrl;
    if (linkedProduct && new URL(linkedProduct, location.origin).pathname !== new URL(component.dataset.productUrl, location.origin).pathname) {
      location.assign(linkedProduct); return;
    }
    const url = new URL(component.dataset.productUrl, location.origin);
    url.searchParams.set('section_id', component.dataset.sectionId);
    url.searchParams.set('option_values', optionValues(component).join(','));
    const focusId = changed.id;
    const quantity = component.querySelector('[name="quantity"]')?.value;
    const properties = [...component.querySelectorAll('[name^="properties["]')].map((node) => ({ name: node.name, value: node.value }));
    component.setAttribute('aria-busy', 'true');
    component.dataset.selectionReady = 'false';
    component.querySelectorAll('[data-add-to-cart], [data-sticky-submit]').forEach((button) => { button.disabled = true; });
    try {
      const response = await fetch(url, { signal: controller.signal, headers: { 'Accept': 'text/html' } });
      if (!response.ok) throw new Error(config.strings.variantError);
      const documentNext = parse(await response.text());
      const next = [...documentNext.querySelectorAll('[data-product-component]')].find((node) => node.dataset.sectionId === component.dataset.sectionId);
      if (!next) throw new Error(config.strings.variantError);
      const state = JSON.parse(next.querySelector('[data-variant-state]').textContent);
      for (const name of ['price', 'buy', 'sticky']) {
        const current = component.querySelector(`[data-fragment="${name}"]`);
        const replacement = next.querySelector(`[data-fragment="${name}"]`);
        if (current && replacement) current.replaceWith(replacement);
      }
      component.querySelector('[data-variant-state]').textContent = JSON.stringify(state);
      component.querySelectorAll('[data-variant-id]').forEach((input) => { input.disabled = !input.value; });
      component.dataset.selectionReady = 'true';
      const quantityField = component.querySelector('[name="quantity"]');
      if (quantityField && quantity) {
        const min = Number(quantityField.min) || 1, step = Number(quantityField.step) || 1;
        const max = quantityField.max ? Number(quantityField.max) : Infinity;
        quantityField.value = Math.min(max, Math.max(min, min + Math.floor((Number(quantity) - min) / step) * step));
      }
      properties.forEach((property) => {
        [...component.querySelectorAll('[name^="properties["]')].filter((node) => node.name === property.name).forEach((node) => { node.value = property.value; });
      });
      selectMedia(component.querySelector('[data-gallery]'), state.mediaId);
      if (component.dataset.primary === 'true') {
        const pageUrl = new URL(location.href);
        pageUrl.searchParams.delete('option_values');
        if (state.id) pageUrl.searchParams.set('variant', state.id);
        else { pageUrl.searchParams.delete('variant'); pageUrl.searchParams.set('option_values', optionValues(component).join(',')); }
        history.replaceState({}, '', pageUrl);
      }
      document.getElementById(focusId)?.focus({ preventScroll: true });
      setupSticky(component);
      if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
      component.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: state, sectionId: component.dataset.sectionId } }));
    } catch (error) {
      if (error.name !== 'AbortError') {
        // Keep both purchase buttons disabled: old variant IDs must never be bought as a new selection.
        errorAt(component.querySelector('[data-product-error]'), config.strings.variantError);
      }
    } finally {
      if (requests.get(component) === controller) component.setAttribute('aria-busy', 'false');
    }
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) openDialog(document.getElementById(opener.dataset.dialogOpen), opener);
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closeDialog(closer.closest('dialog'));
    const navLink = event.target.closest('#MobileMenu a');
    if (navLink) closeDialog(navLink.closest('dialog'));
    const cartOpener = event.target.closest('[data-cart-open]');
    if (cartOpener && document.getElementById('CartDrawer')) {
      event.preventDefault();
      if (!cartBusy) refreshCart().then(() => openDialog(document.getElementById('CartDrawer'), cartOpener)).catch(() => location.assign(config.routes.cart));
    }
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      const input = stepper.closest('.quantity-selector').querySelector('input');
      if (Number(stepper.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const thumb = event.target.closest('[data-media-target]');
    if (thumb) selectMedia(thumb.closest('[data-gallery]'), thumb.dataset.mediaTarget, true);
    const remove = event.target.closest('#CartDrawer [data-cart-remove]');
    if (remove) { event.preventDefault(); changeCart(remove.dataset.lineKey, 0); }
  });
  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-product-form]')) { event.preventDefault(); addToCart(event.target, event.submitter); }
    if (event.target.id === 'CartDrawerForm' && cartBusy) event.preventDefault();
  });
  document.addEventListener('change', (event) => {
    const node = event.target;
    if (node.matches('[data-option-value-id], [data-option-select]')) updateVariant(node.closest('[data-product-component]'), node);
    if (node.matches('#CartDrawer [data-cart-quantity]') && node.reportValidity()) changeCart(node.dataset.lineKey, Number(node.value), node.id);
  });
  function initialize(scope = document) {
    registerDialogs(scope);
    scope.querySelectorAll('[data-variant-id]').forEach((input) => { input.disabled = !input.value; });
    scope.querySelectorAll('[data-gallery]').forEach(setupGallery);
    scope.querySelectorAll('[data-product-component]').forEach(setupSticky);
    if (scope.querySelector('model-viewer') && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: (error) => {
        if (error || !window.Shopify.ModelViewerUI) return;
        scope.querySelectorAll('model-viewer').forEach((model) => {
          if (model.dataset.viewerReady) return;
          model.dataset.viewerReady = 'true';
          new window.Shopify.ModelViewerUI(model);
        });
      } }]);
    }
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-product-component], [data-gallery]').forEach((node) => { observers.get(node)?.disconnect(); requests.get(node)?.abort(); });
    if (event.target.querySelector('[data-sticky-atc]')) document.body.classList.remove('has-sticky-atc');
  });
  window.addEventListener('resize', () => {
    if (matchMedia('(min-width: 990px)').matches) {
      document.body.classList.remove('has-sticky-atc');
      document.querySelectorAll('[data-sticky-atc]').forEach((node) => { node.hidden = true; });
    }
  }, { passive: true });
  initialize();
})();
